import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import icon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";
import { ALL_CATEGORIES_ID, NO_CATEGORIES_ID } from "select-kit/components/category-drop";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class CategoryDropMoreCollection extends Component {
  static {
    dt7948.g(this.prototype, "site", [service]);
  }
  #site = (dt7948.i(this, "site"), void 0);
  tagName = "";
  get moreCount() {
    if (!this.args.selectKit.totalCount) {
      return 0;
    }
    const currentCount = this.args.collection.content.filter(category => category.id !== NO_CATEGORIES_ID && category.id !== ALL_CATEGORIES_ID).length;
    return this.args.selectKit.totalCount - currentCount;
  }
  get slugPath() {
    return this.args.selectKit.options.parentCategory.path.substring("/c/".length);
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.moreCount}}\n      <div class=\"category-drop-footer\">\n        <span>\n          {{i18n \"categories.plus_more_count\" (hash count=this.moreCount)}}\n        </span>\n\n        {{#if @selectKit.options.parentCategory}}\n          <LinkTo @route=\"discovery.subcategories\" @model={{this.slugPath}}>\n            {{i18n \"categories.view_all\"}}\n            {{icon \"up-right-from-square\"}}\n          </LinkTo>\n        {{else}}\n          <LinkTo @route=\"discovery.categories\">\n            {{i18n \"categories.view_all\"}}\n            {{icon \"up-right-from-square\"}}\n          </LinkTo>\n        {{/if}}\n      </div>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        i18n,
        hash,
        LinkTo,
        icon
      })
    }), this);
  }
}